import { Component, Input, OnInit, HostBinding } from '@angular/core'
import { LocaleService } from 'framework/locale/services/locale.service'

@Component({
    selector: 'mg-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    homeUrl: string = '/'

    @HostBinding('class.no-background')
    @Input()
    noBackground: boolean = false

    constructor(private localeService: LocaleService) {}

    ngOnInit() {
        if (typeof window !== 'undefined') {
            const currentLanguage = this.localeService.language
            const originUrl = window.location.origin

            if (window.location.pathname.match(/^\/\w{2}\//)) {
                this.homeUrl = `${originUrl}/${currentLanguage}`
            } else {
                this.homeUrl = originUrl
            }
        }
    }
}
